var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 50,
    viewBox: "0 0 51 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.54036 12.4368C5.89453 15.9368 4.33203 20.291 4.33203 24.9994C4.33203 36.4994 13.6654 45.8327 25.1654 45.8327C36.6654 45.8327 45.9987 36.4994 45.9987 24.9994C45.9987 13.4993 36.6654 4.16602 25.1654 4.16602",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.582 24.9993C10.582 33.0618 17.1029 39.5827 25.1654 39.5827C33.2279 39.5827 39.7487 33.0618 39.7487 24.9993C39.7487 16.9368 33.2279 10.416 25.1654 10.416",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.166 33.3327C29.7702 33.3327 33.4993 29.6035 33.4993 24.9993C33.4993 20.3952 29.7702 16.666 25.166 16.666",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChart);
export default __webpack_public_path__ + "static/media/chart.37be203c8873b7ac77074f7dacfd70d1.svg";
export { ForwardRef as ReactComponent };